import findIndex from 'lodash/findIndex';
import { CURRENT_ITEMS_FIELD_SEPARATOR, DEALERS_PER_PAGE, TOTAL_ITEMS_FIELD_SEPARATOR, } from './constants';
const getMaxPageIndex = (totalItems, itemsPerPage) => Math.ceil(totalItems / itemsPerPage);
const getPaginationFirstItem = (isLastPage, lastItem, dealerListLength) => {
    const lastPageItemAmount = dealerListLength % DEALERS_PER_PAGE;
    return isLastPage && lastPageItemAmount
        ? lastItem - lastPageItemAmount
        : lastItem - DEALERS_PER_PAGE;
};
export const getPaginationProperties = (currentPage, dealerList) => {
    const dealerListLength = dealerList.length;
    const maxPageIndex = getMaxPageIndex(dealerListLength, DEALERS_PER_PAGE);
    const isLastPage = maxPageIndex === currentPage;
    const lastItem = isLastPage ? dealerListLength : currentPage * DEALERS_PER_PAGE;
    const firstItem = getPaginationFirstItem(isLastPage, lastItem, dealerListLength);
    const currentDealers = dealerList?.slice(firstItem, lastItem);
    return {
        firstItem,
        onlyOnePage: maxPageIndex === 1,
        lastItem,
        currentDealers,
        maxPageIndex,
        dealerListLength,
    };
};
export const getPaginationLabel = ({ paginationTemplateLabel, firstItem, lastItem, dealerListLength, }) => {
    const splitedTextByCurrent = paginationTemplateLabel.split(CURRENT_ITEMS_FIELD_SEPARATOR);
    const labelCurrentPart = [
        splitedTextByCurrent[0],
        `${firstItem + 1}-${lastItem}`,
        splitedTextByCurrent[1],
    ].join('');
    const splitedTextByTotal = labelCurrentPart.split(TOTAL_ITEMS_FIELD_SEPARATOR);
    return [splitedTextByTotal[0], `${dealerListLength}`, splitedTextByTotal[1]].join('');
};
export const getDealerAddress = (dealer, isGBCountyRoot = false) => {
    const address = `${dealer.addressLines[0]},` || '';
    const zipCode = isGBCountyRoot ? dealer.zipCode || '' : `${dealer.zipCode},` || '';
    const city = isGBCountyRoot ? `${dealer.city},` || '' : dealer.city || '';
    return isGBCountyRoot ? `${address} ${city} ${zipCode}` : `${address} ${zipCode} ${city}`;
};
export const getActivePageByItemId = (list, itemId, itemsPerPage = DEALERS_PER_PAGE) => {
    const itemIndex = findIndex(list, ({ vicinityId }) => vicinityId === itemId);
    if (itemIndex < 0) {
        return 0;
    }
    const humanIndex = itemIndex + 1;
    return Math.floor(humanIndex / itemsPerPage) + (humanIndex % itemsPerPage ? 1 : 0);
};
